import _asyncToGenerator from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/regenerator";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { TWSubscriptionPlanPicker } from '../TWSubscriptionPlanPicker';
import { TWToggleButton } from '../TWToggleButton';
import { AssetResourceType } from '../../interfaces';
import { Button, Checkbox, RadioButton } from '../../subkit-ui';
import classNames from 'classnames';
import React, { useEffect, useState } from 'react';
import { emailCampaignCreated } from '../../utils/segmentAnalytics';
import { EmailTargetOption } from '../../types';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var AccessLevel;

(function (AccessLevel) {
  AccessLevel["PUBLIC"] = "public";
  AccessLevel["PLAN"] = "plan";
})(AccessLevel || (AccessLevel = {}));

export var PublishPostDropdown = function PublishPostDropdown(_ref) {
  var _servicePostMailingLi, _resources$post$id2, _resources$post$id2$p, _servicePostMailingLi2, _servicePostMailingLi3, _servicePostMailingLi4;

  var post = _ref.post,
      resources = _ref.resources,
      loading = _ref.loading,
      servicePlans = _ref.servicePlans,
      setShowPublished = _ref.setShowPublished,
      servicePostMailingList = _ref.servicePostMailingList,
      setPlansForAsset = _ref.setPlansForAsset,
      serviceId = _ref.serviceId,
      setIsPublished = _ref.setIsPublished,
      emailPost = _ref.emailPost,
      provider = _ref.provider,
      serviceName = _ref.serviceName,
      getPlansForAsset = _ref.getPlansForAsset;

  var _useState = useState(false),
      isPublishing = _useState[0],
      setIsPublishing = _useState[1]; // VISIBILTY / ACCESS


  var _useState2 = useState(function () {
    var _resources$post$id, _resources$post$id$pl;

    if (post.id && ((_resources$post$id = resources[post.id]) === null || _resources$post$id === void 0 ? void 0 : (_resources$post$id$pl = _resources$post$id.plans) === null || _resources$post$id$pl === void 0 ? void 0 : _resources$post$id$pl.length) > 0 && resources[post.id].resourceType === AssetResourceType.POST) {
      return AccessLevel.PLAN;
    }

    return AccessLevel.PUBLIC;
  }),
      accessLevel = _useState2[0],
      setAccessLevel = _useState2[1];

  var _useState3 = useState([]),
      plansWithAccess = _useState3[0],
      setPlansWithAccess = _useState3[1]; // SENDING


  var _useState4 = useState(false),
      sendByEmailSwitch = _useState4[0],
      setSendByEmailSwitch = _useState4[1];

  var _useState5 = useState(false),
      leadsToggle = _useState5[0],
      setLeadsToggle = _useState5[1];

  var _useState6 = useState(false),
      subsToggle = _useState6[0],
      setSubsToggle = _useState6[1];

  var _useState7 = useState([]),
      sendToPlans = _useState7[0],
      setSendToPlans = _useState7[1];

  var selectedSendToPlans = servicePlans.filter(function (p) {
    return sendToPlans.includes(p.id);
  }).reduce(function (acc, p) {
    acc[p.id] = p;
    return acc;
  }, {});
  var selectedPlansWithAccess = servicePlans.filter(function (p) {
    return plansWithAccess.includes(p.id);
  }).reduce(function (acc, p) {
    acc[p.id] = p;
    return acc;
  }, {}); // WARNING: appears to exclude subscribers who have already received an email campaign that was generated via this same post.id

  var serviceCustomersPromoTrueWithSub = (servicePostMailingList === null || servicePostMailingList === void 0 ? void 0 : (_servicePostMailingLi = servicePostMailingList.subscribers) === null || _servicePostMailingLi === void 0 ? void 0 : _servicePostMailingLi.filter(function (sc) {
    return Array.isArray(sc.subscription) && sc.subscription.length > 0;
  })) || [];
  var customerCountPerPlan = {};
  serviceCustomersPromoTrueWithSub === null || serviceCustomersPromoTrueWithSub === void 0 ? void 0 : serviceCustomersPromoTrueWithSub.forEach(function (sc) {
    // in practice, only expect to see one subscription
    var _iterator = _createForOfIteratorHelper(sc.subscription),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _subscription$plan;

        var subscription = _step.value;
        if (!((_subscription$plan = subscription.plan) !== null && _subscription$plan !== void 0 && _subscription$plan.id)) continue;

        if (!customerCountPerPlan[subscription.plan.id]) {
          customerCountPerPlan[subscription.plan.id] = 1;
        } else {
          customerCountPerPlan[subscription.plan.id] += 1;
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  });
  var plansWithAccessToPost = servicePlans.map(function (p) {
    return p.id;
  });

  if (((_resources$post$id2 = resources[post.id]) === null || _resources$post$id2 === void 0 ? void 0 : (_resources$post$id2$p = _resources$post$id2.plans) === null || _resources$post$id2$p === void 0 ? void 0 : _resources$post$id2$p.length) > 0) {
    plansWithAccessToPost = resources[post.id].plans.map(function (p) {
      return p.id;
    });
  }

  var numberOfEmailRecipients = 0;
  if (leadsToggle) numberOfEmailRecipients += (_servicePostMailingLi2 = servicePostMailingList === null || servicePostMailingList === void 0 ? void 0 : (_servicePostMailingLi3 = servicePostMailingList.leads) === null || _servicePostMailingLi3 === void 0 ? void 0 : _servicePostMailingLi3.length) !== null && _servicePostMailingLi2 !== void 0 ? _servicePostMailingLi2 : 0;

  if (subsToggle) {
    sendToPlans.forEach(function (planId) {
      var _customerCountPerPlan;

      numberOfEmailRecipients += (_customerCountPerPlan = customerCountPerPlan[planId]) !== null && _customerCountPerPlan !== void 0 ? _customerCountPerPlan : 0;
    });
  }

  var cannotPublish = sendByEmailSwitch && (!subsToggle && !leadsToggle || numberOfEmailRecipients === 0);

  var handleToggleSubs = function handleToggleSubs() {
    var nextToggleSubs = !subsToggle;

    if (!nextToggleSubs) {
      // unselecting the subscribers checkbox = unselect all plan checkboxes
      setSendToPlans([]);
    } else {
      // selecting the subscribers checkbox = select all plan checkboxes
      setSendToPlans(servicePlans.map(function (p) {
        return p.id;
      }));
    }

    setSubsToggle(nextToggleSubs);
  };

  var handleAccessLevelChange = function handleAccessLevelChange(_ref2) {
    var isChecked = _ref2.isChecked,
        value = _ref2.value;
    if (!isChecked) return;
    setAccessLevel(value);
    var plansWithAccessIds = [];

    if (value === AccessLevel.PLAN) {
      servicePlans.forEach(function (plan) {
        plansWithAccessIds.push(plan.id);
      });
    }

    setPlansWithAccess(plansWithAccessIds);
  };

  var onSelectPlanWithAccessOption = function onSelectPlanWithAccessOption(plans) {
    if (plans.length === 0) {
      setAccessLevel(AccessLevel.PUBLIC);
    }

    setPlansWithAccess(plans);
  };

  var onSelectSendToPlanOption = function onSelectSendToPlanOption(plans) {
    setSubsToggle(plans.length > 0);
    setSendToPlans(plans);
  };

  var sendEmail = function sendEmail() {
    if (subsToggle) {
      emailPost(serviceId, post.id, [EmailTargetOption.SUBSCRIBERS], sendToPlans);
      emailCampaignCreated({
        serviceId: serviceId,
        serviceName: serviceName,
        post: post,
        target: [EmailTargetOption.SUBSCRIBERS],
        provider: provider
      });
    }

    if (leadsToggle) {
      emailPost(serviceId, post.id, [EmailTargetOption.LEADS], []);
      emailCampaignCreated({
        serviceId: serviceId,
        serviceName: serviceName,
        post: post,
        target: [EmailTargetOption.LEADS],
        provider: provider
      });
    }
  };

  var onPublish = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setIsPublishing(true);
              _context.t0 = accessLevel;
              _context.next = _context.t0 === AccessLevel.PUBLIC ? 4 : _context.t0 === AccessLevel.PLAN ? 7 : 10;
              break;

            case 4:
              _context.next = 6;
              return setPlansForAsset({
                serviceId: serviceId,
                resourceId: post.id,
                resourceType: AssetResourceType.POST,
                planIds: []
              });

            case 6:
              return _context.abrupt("break", 11);

            case 7:
              _context.next = 9;
              return setPlansForAsset({
                serviceId: serviceId,
                resourceId: post.id,
                resourceType: AssetResourceType.POST,
                planIds: Object.keys(selectedPlansWithAccess)
              });

            case 9:
              return _context.abrupt("break", 11);

            case 10:
              throw new Error('Unimplemented case in PublishPost');

            case 11:
              if (sendByEmailSwitch) {
                sendEmail();
              }

              _context.next = 14;
              return setIsPublished(true);

            case 14:
              setIsPublishing(false);
              setShowPublished(false);

            case 16:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function onPublish() {
      return _ref3.apply(this, arguments);
    };
  }();

  useEffect(function () {
    getPlansForAsset({
      resourceId: post.id,
      resourceType: AssetResourceType.POST,
      serviceId: serviceId
    });
  }, []);
  return /*#__PURE__*/_jsxs("div", {
    className: "fixed bottom-0 w-full sm:w-auto p2 box-shadow sm:box-shadow-none bg-white sm:block sm:bottom-auto",
    "data-cy": "publish-dropdown",
    children: [/*#__PURE__*/_jsx("div", {
      className: "flex justify-end",
      children: /*#__PURE__*/_jsx("a", {
        href: "#",
        onClick: function onClick() {
          setShowPublished(false);
        },
        children: /*#__PURE__*/_jsx("i", {
          className: "fas fa-times text-gray-500"
        })
      })
    }), /*#__PURE__*/_jsx("h2", {
      className: "font-normal font-serif text-xl",
      children: "Ready to Publish?"
    }), /*#__PURE__*/_jsxs("div", {
      className: classNames("my-6 border-bottom border-gray-300"),
      children: [/*#__PURE__*/_jsx("div", {
        className: classNames("fw-500 text-base"),
        children: /*#__PURE__*/_jsx("p", {
          children: "This post is visible to:"
        })
      }), /*#__PURE__*/_jsxs("div", {
        className: "flex mb-4",
        children: [/*#__PURE__*/_jsx(RadioButton, {
          name: "visibility",
          id: AccessLevel.PUBLIC,
          onChange: handleAccessLevelChange,
          checked: accessLevel === AccessLevel.PUBLIC,
          value: AccessLevel.PUBLIC
        }), /*#__PURE__*/_jsx("label", {
          htmlFor: "".concat(AccessLevel.PUBLIC),
          className: classNames("mx-2 fw-500"),
          children: "Everybody"
        })]
      }), /*#__PURE__*/_jsxs("div", {
        className: "flex mb-4",
        children: [/*#__PURE__*/_jsx(RadioButton, {
          name: "visibility",
          id: AccessLevel.PLAN,
          onChange: handleAccessLevelChange,
          checked: accessLevel === AccessLevel.PLAN,
          value: AccessLevel.PLAN
        }), /*#__PURE__*/_jsxs("div", {
          className: classNames("mx-2"),
          children: [/*#__PURE__*/_jsx("label", {
            htmlFor: "".concat(AccessLevel.PLAN),
            className: classNames("fw-500"),
            children: "Subscribers"
          }), /*#__PURE__*/_jsxs("div", {
            className: classNames("my-2", "opacity-".concat(accessLevel === AccessLevel.PLAN ? '100' : '1'), "".concat(accessLevel === AccessLevel.PLAN ? '' : 'text-gray-500')),
            "data-cy": "select-plans",
            children: [!loading && servicePlans.length > 0 && /*#__PURE__*/_jsx(_Fragment, {
              children: /*#__PURE__*/_jsx(TWSubscriptionPlanPicker, {
                servicePlans: servicePlans,
                selectedPlans: accessLevel === AccessLevel.PLAN ? selectedPlansWithAccess : {},
                setSelectedPlans: function setSelectedPlans(plans) {
                  onSelectPlanWithAccessOption(Object.keys(plans));
                },
                planText: function planText(plan) {
                  return /*#__PURE__*/_jsx("div", {
                    className: classNames({
                      'text-gray-500': !plansWithAccessToPost.includes(plan.id)
                    }, "".concat(accessLevel === AccessLevel.PLAN ? '' : 'text-gray-500')),
                    children: "".concat(plan.name, " (").concat(customerCountPerPlan[plan.id] || 0, ")")
                  }, plan.id);
                }
              })
            }), !loading && servicePlans.length === 0 && /*#__PURE__*/_jsx(_Fragment, {
              children: "Create a subscription plan to enable this setting."
            }), loading && /*#__PURE__*/_jsx(_Fragment, {
              children: "Please wait..."
            })]
          })]
        })]
      })]
    }), /*#__PURE__*/_jsx("div", {
      className: "mb-4",
      children: /*#__PURE__*/_jsxs("div", {
        className: "flex",
        children: [/*#__PURE__*/_jsx("div", {
          className: "col-7",
          children: /*#__PURE__*/_jsx("h3", {
            className: "m-0 fw-500",
            children: "Send By Email"
          })
        }), /*#__PURE__*/_jsx("div", {
          className: "col-5",
          children: /*#__PURE__*/_jsx(TWToggleButton, {
            checked: sendByEmailSwitch,
            name: "sendByEmail",
            onChange: function onChange() {
              setSendByEmailSwitch(!sendByEmailSwitch);
            }
          })
        })]
      })
    }), sendByEmailSwitch && /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsxs("div", {
        className: classNames('flex mb-4 mt-3'),
        children: [/*#__PURE__*/_jsx(Checkbox, {
          name: "leads",
          id: "leads",
          checked: leadsToggle,
          onChange: function onChange() {
            setLeadsToggle(!leadsToggle);
          }
        }), /*#__PURE__*/_jsx("div", {
          className: classNames("mx-0"),
          children: /*#__PURE__*/_jsxs("label", {
            htmlFor: "leads",
            className: classNames("fw-500"),
            children: ["Leads", " ", /*#__PURE__*/_jsxs("span", {
              className: "text-gray-500 fw-400",
              children: ["(", servicePostMailingList === null || servicePostMailingList === void 0 ? void 0 : (_servicePostMailingLi4 = servicePostMailingList.leads) === null || _servicePostMailingLi4 === void 0 ? void 0 : _servicePostMailingLi4.length, ")"]
            })]
          })
        })]
      }), /*#__PURE__*/_jsxs("div", {
        id: "plans",
        className: "flex mb-4",
        children: [/*#__PURE__*/_jsx(Checkbox, {
          name: "plans",
          id: "plans",
          checked: subsToggle,
          onChange: handleToggleSubs
        }), /*#__PURE__*/_jsxs("div", {
          className: classNames("mx-0"),
          children: [/*#__PURE__*/_jsxs("label", {
            htmlFor: "plans",
            className: classNames("fw-500"),
            children: ["Subscribers ", /*#__PURE__*/_jsxs("span", {
              className: "text-gray-500 fw-400",
              children: ["(", serviceCustomersPromoTrueWithSub.length, ")"]
            })]
          }), /*#__PURE__*/_jsxs("div", {
            className: classNames("my-2"),
            children: [!loading && servicePlans.length > 0 && /*#__PURE__*/_jsx(_Fragment, {
              children: /*#__PURE__*/_jsx(TWSubscriptionPlanPicker, {
                servicePlans: servicePlans,
                selectedPlans: selectedSendToPlans,
                setSelectedPlans: function setSelectedPlans(plans) {
                  return onSelectSendToPlanOption(Object.keys(plans));
                },
                planText: function planText(plan) {
                  return /*#__PURE__*/_jsx("div", {
                    className: classNames({
                      'text-gray-500': !plansWithAccessToPost.includes(plan.id)
                    }, "".concat(accessLevel === AccessLevel.PLAN ? '' : 'text-gray-500')),
                    children: "".concat(plan.name, " (").concat(customerCountPerPlan[plan.id] || 0, ")")
                  }, plan.id);
                }
              })
            }), !loading && servicePlans.length === 0 && /*#__PURE__*/_jsx(_Fragment, {
              children: "Create a subscription plan to enable this setting."
            }), loading && /*#__PURE__*/_jsx(_Fragment, {
              children: "Please wait..."
            })]
          })]
        })]
      })]
    }), /*#__PURE__*/_jsxs("div", {
      className: "flex flex-col sm:flex-row py-2",
      children: [/*#__PURE__*/_jsx(Button, {
        text: isPublishing ? 'Publishing' : 'Publish',
        disabled: isPublishing || cannotPublish,
        onClick: onPublish,
        "data-cy": "publish-post",
        classes: "mb-4 sm:mb-0 sm:mr-4"
      }), /*#__PURE__*/_jsx(Button, {
        text: "Cancel",
        type: "secondary",
        onClick: function onClick() {
          setShowPublished(false);
        },
        "data-cy": "cancel-post"
      })]
    })]
  });
};